module.exports = __webpack_public_path__ + "img/img1.e936fb4f.png";